import { useRef, useState } from 'react';

// third-party
import { useIntl } from 'react-intl';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, ClickAwayListener, List, ListItemButton, ListItemText, Paper, Popper } from '@mui/material';

// project-imports
import IconButton from 'components/@extended/IconButton';
import MainCard from 'components/MainCard';
import Transitions from 'components/@extended/Transitions';
import useConfig from 'hooks/useConfig';

// assets
import { Translate } from 'iconsax-react';

// types
import { I18n } from 'types/config';

// ==============================|| HEADER CONTENT - LANGUAGE ||============================== //
//
// Each language is named in its own script, so a reader who cannot find their own language on the
// current screen can still find it.

const LANGUAGES: { value: I18n; label: string }[] = [
  { value: 'ru', label: 'Русский' },
  { value: 'uz', label: "O'zbekcha" },
  { value: 'en', label: 'English' }
];

const LanguageToggle = () => {
  const theme = useTheme();
  const intl = useIntl();
  const { i18n, onChangeLocalization } = useConfig();

  const anchorRef = useRef<any>(null);
  const [open, setOpen] = useState(false);

  const choose = (value: I18n) => {
    onChangeLocalization(value);
    setOpen(false);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 0.5 }}>
      <IconButton
        ref={anchorRef}
        color="secondary"
        variant="light"
        aria-label={intl.formatMessage({ id: 'header.language' })}
        onClick={() => setOpen((prev) => !prev)}
        size="large"
        sx={{ color: 'secondary.main', bgcolor: open ? 'secondary.200' : 'secondary.100', p: 1 }}
      >
        <Translate variant="Bulk" size={20} />
      </IconButton>

      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        popperOptions={{ modifiers: [{ name: 'offset', options: { offset: [0, 9] } }] }}
      >
        {({ TransitionProps }) => (
          <Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
            <Paper sx={{ boxShadow: theme.customShadows.z1, width: 180 }}>
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <MainCard content={false} border={false}>
                  <List component="nav" sx={{ p: 1 }}>
                    {LANGUAGES.map((language) => (
                      <ListItemButton key={language.value} selected={i18n === language.value} onClick={() => choose(language.value)}>
                        <ListItemText primary={language.label} />
                      </ListItemButton>
                    ))}
                  </List>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
};

export default LanguageToggle;
